export enum ReportType {
  EVENT_LIST,
  RESERVATION_SUMMARY,
  PAYMENT_SUMMARY,
  RSVP_SUMMARY,
  RESERVATION_COMPARE,
  RSVP_COMPARE
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/report-type.enum.ts